<div class="hotkey">Next time, hit <span class="key">CTRL + ENTER</span> to open search!</div>
